interface ApiUrls {
  getVesselsList: string;
  getInfoById: (id: number) => string;
  selectReportee: string;
}

interface ExternalUrls {
  orgSearch: (orgNumber: string) => string;
}

export const apiUrls: ApiUrls = {
  getVesselsList: 'test/list',
  getInfoById: id => `/test/${id}`,
  selectReportee: '/select-reportee'
};

export const externalUrls: ExternalUrls = {
  orgSearch: orgNumber =>
    `https://data.brreg.no/enhetsregisteret/api/enheter/${orgNumber}`
};
